document.addEventListener("DOMContentLoaded", function () {
  const categoryFilterSelect = document.getElementById("plant-filter--categories");
  const countryFilterSelect = document.getElementById("plant-filter--countries");
  const typeFilters = document.getElementsByClassName('js-plant-filter--type');

  if (categoryFilterSelect) {
    categoryFilterSelect.addEventListener('change', function () {
      updateFilter("category", categoryFilterSelect.value.toString());
    });
  }

  if (countryFilterSelect) {
    countryFilterSelect.addEventListener('change', function () {
      updateFilter("country", countryFilterSelect.value.toString());
    });
  }

  if (typeFilters) {
    for (let i = 0; i < typeFilters.length; i++) {
      const typeFilter = typeFilters[i];
      typeFilter.addEventListener('click', function (e) {
        const updatedFilters = document.getElementsByClassName('js-plant-filter--type');
        const updatedValue = [...updatedFilters].filter(x => x.checked).map(x => x.value).join(",");
        updateFilter("types", updatedValue);
      });
    }
  }
});

function updateFilter(filterName, filterValue) {
  const pageUrl = window.location.href.replace(location.search, "");
  const urlParams = new URLSearchParams(location.search);

  if (filterValue) {
    urlParams.set(filterName, filterValue);
  } else {
    urlParams.delete(filterName);
  }

  const urlParamString = urlParams.toString();
  if (urlParamString && urlParamString.length > 0) {
    window.location.assign(`${pageUrl}?${urlParams.toString()}`);
  } else {
    window.location.assign(pageUrl);
  }
}